import { Navigate } from "react-router";

export default function ForgotPassword() {
  return <Navigate to="/auth/login" replace />;
}
